import { ReactComponent as CompletedIcon } from "../../../../assets/icons/completed.svg";
import { ReactComponent as PendingIcon } from "../../../../assets/icons/pending.svg";

const ResultCard = ({ info,showDetails }) => {
    return (
        <div className="card m-2 flex-fill">
            <div className="row w-100 h-100 g-0 p-3">
                <div className="col-md-3 col-sm-4">
                    {info.status === "Expired" ? (
                        <PendingIcon width="48" />
                    ) : (
                        <CompletedIcon width="48" />
                    )}
                </div>
                <div className="col">
                    <b className="mb-4">{info.licensee}</b>
                    <div className="text-3">
                        <div>
                            {info.licenceType} - {info.licenceNumber}
                        </div>
                        <div>Expiry Date : {info.expiryDate}</div>
                        <div>
                            {info.suburb}, {info.postcode}
                        </div>
                    </div>
                </div>
            </div>
            <div onClick={()=>{showDetails(info.licenceID)}} className="card-footer text-center text-3 p-3 btn">
                See Details
            </div>
        </div>
    );
};

export default ResultCard;
